<template>
  <div class="">
    <div class="breadcrumb-area pos-relative w-100">
      <h5 class="mb-0">Chi tiết yêu cầu đăng ký Combo bán hàng</h5>
      <div class="bth-group gap-2">
        <button class="btn btn-outline-secondary mr-2" @click="goBack">Quay lại</button>

        <button
          v-if="['PENDING', 'SUPPLEMENTED']?.includes(data?.status)"
          class="btn btn-outline-secondary mr-2"
          @click="handleCreateContract"
        >
          Sinh hợp đồng
        </button>

        <button
          v-if="
            ['PENDING', 'SUPPLEMENTED']?.includes(data?.status) &&
            dataPermission &&
            dataPermission.includes('CNPS_AGENT_COMBO_REGISTRATION_REQUEST_APPROVE')
          "
          @click="showSupplementalModal"
          class="btn btn-outline-secondary mr-2"
        >
          Yêu cầu bổ sung
        </button>

        <button
          v-if="['PENDING', 'REQUIRED', 'PROCESSING']?.includes(data?.status)"
          @click="showRejectionModal"
          class="btn btn-outline-danger mr-2"
        >
          Từ chối
        </button>

        <button
          v-if="data?.status === 'APPROVED'"
          @click="showDigitalSignatureModal"
          class="btn btn-outline-primary mr-2"
        >
          Cập nhật TT CKS
        </button>

        <button
          v-if="data?.status === 'APPROVED'"
          @click="showTaxAuthorityModal"
          class="btn btn-outline-info mr-2"
        >
          Cập nhật TT thẩm định CQ thuế
        </button>

        <!-- Bổ sung nút vào phần buttons -->
        <button
          v-if="data?.status === 'APPROVED'"
          @click="showNotifyMcModal"
          class="btn btn-outline-success mr-2"
        >
          Thông báo MC hoàn tất cấu hình
        </button>
      </div>
    </div>

    <div class="p-10 pt-15 b-t-1-869fb229">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border"></div>
      </div>

      <div v-else-if="data" class="mx-4 mt-2">
        <!-- Thông tin merchant -->
        <div class="row">
          <div class="col-md-5">
            <!-- <h6 class="font-weight-bold mb-3">Thông tin merchant</h6> -->

            <Card
              style="box-shadow: none; border: 1px solid #d7d7d7; margin-bottom: 20px"
              title="Thông tin yêu cầu"
              v-if="data"
            >
              <Content title="Mã yêu cầu" :content="data?.code || ''"></Content>
              <Content title="Thời gian tạo">
                {{ formatDate(data?.createdDate) }}
              </Content>
              <Content title="Gói combo">
                {{ getNameCombo(data?.packageCode) }}
              </Content>

              <Content title="Trạng thái">
                <span class="badge" :class="getStatusClass(data?.status)">
                  {{ data?.statusStr || data?.status }}
                </span>
              </Content>
              <Content title="Trạng thái thanh toán">
                <span
                  v-if="data?.paymentStatusStr"
                  class="badge"
                  :class="getStatusClass(data?.paymentStatusStr)"
                >
                  {{ data?.paymentStatusStr || data?.paymentStatusStr }}
                </span>
              </Content>
              <Content title="Trạng thái chữ ký số">
                <span
                  v-if="data?.digitalSignatureRegistrationStatusStr"
                  class="badge"
                  :class="
                    getDigitalSignatureRegistrationStatus(data?.digitalSignatureRegistrationStatus)
                  "
                >
                  {{
                    data?.digitalSignatureRegistrationStatusStr ||
                    data?.digitalSignatureRegistrationStatus
                  }}
                </span>
              </Content>
              <Content title="Trạng thái thẩm định CQ thuế">
                <span
                  v-if="data?.taxAuthorityVerifyStatusStr"
                  class="badge"
                  :class="getTaxAuthorityVerifyStatus(data?.digitalSignatureRegistrationStatus)"
                >
                  {{
                    data?.taxAuthorityVerifyStatusStr || data?.digitalSignatureRegistrationStatus
                  }}
                </span>
              </Content>

              <Content v-if="data?.contractId" title="Mã hợp đồng">
                <a :href="getContractUrl(data?.contractId)" target="_blank" class="text-primary">
                  {{ data?.contractId }}
                  <i class="fas fa-external-link-alt ml-1"></i>
                </a>
              </Content>
              <Content
                v-if="data?.inviteCode"
                title="Mã giới thiệu"
                :content="data?.inviteCode"
              ></Content>
              <Content title="Ghi chú" :content="data?.reason"></Content>
              <Content v-if="data?.agentName" title="Agent" :content="data?.agentName"></Content>
              <Content
                v-if="data?.keeper && data?.keeper.regionName"
                title="Khu vực"
                :content="data?.keeper.regionName"
              >
              </Content>
              <!-- Lý do yêu cầu bổ sung -->
              <div v-if="data?.supplementRequestReason">
                <Content
                  title="Lý do yêu cầu bổ sung"
                  :content="data?.supplementRequestReason"
                ></Content>
                <Content
                  v-if="data?.supplementRequestNote"
                  title="Ghi chú bổ sung"
                  :content="data?.supplementRequestNote"
                ></Content>
              </div>

              <!-- Lý do từ chối yêu cầu -->
              <div v-if="data?.rejectionReason">
                <Content title="Lý do từ chối yêu cầu" :content="data?.rejectionReason"></Content>
                <Content
                  v-if="data?.rejectionNote"
                  title="Ghi chú từ chối"
                  :content="data?.rejectionNote"
                ></Content>
              </div>

              <!-- Lý do từ chối chữ ký số -->
              <div v-if="data?.digitalSignatureRejectionReason">
                <Content
                  title="Lý do từ chối chữ ký số"
                  :content="data?.digitalSignatureRejectionReason"
                ></Content>
                <Content
                  v-if="data?.digitalSignatureRejectionNote"
                  title="Ghi chú từ chối chữ ký số"
                  :content="data?.digitalSignatureRejectionNote"
                ></Content>
              </div>

              <!-- Lý do từ chối thẩm định CQ thuế -->
              <div v-if="data?.taxAuthorityRejectionReason">
                <Content
                  title="Lý do từ chối TĐ CQ thuế"
                  :content="data?.taxAuthorityRejectionReason"
                ></Content>
                <Content
                  v-if="data?.taxAuthorityRejectionNote"
                  title="Ghi chú từ chối TĐ CQ thuế"
                  :content="data?.taxAuthorityRejectionNote"
                ></Content>
              </div>
            </Card>

            <!-- Thông tin merchant -->
            <Card
              style="box-shadow: none; border: 1px solid #d7d7d7"
              title="Thông tin merchant"
              v-if="data"
            >
              <Content title="Tên" :content="data?.merchantName || ''"></Content>
              <Content title="ĐKKD" :content="data?.businessRegistrationNumber || ''"></Content>
              <Content title="Địa chỉ" :content="data?.merchantAddress || ''"></Content>
              <Content
                v-if="data?.representativeName"
                title="Người đại diện"
                :content="data?.representativeName"
              >
              </Content>
              <Content
                v-if="data?.representativeEmail"
                title="Email người đại diện"
                :content="data?.representativeEmail"
              >
              </Content>
              <Content
                v-if="data?.representativeMobile"
                title="SĐT người đại diện"
                :content="data?.representativeMobile"
              >
              </Content>
              <Content
                v-if="data?.identityNumber"
                title="Số CCCD"
                :content="data?.identityNumber"
              ></Content>
            </Card>
          </div>

          <!-- Ảnh & file đính kèm -->
          <div class="col-md-7">
            <h6 class="font-weight-bold mb-3">Ảnh & file đính kèm</h6>

            <!-- Ảnh giấy ĐKKD -->
            <div class="attachment-group">
              <label class="attachment-label">Ảnh giấy ĐKKD:</label>
              <div
                class="image-gallery"
                v-if="
                  data?.businessRegistrationNumberImages &&
                  data?.businessRegistrationNumberImages.length
                "
              >
                <div
                  @click="viewImage(image, 'Ảnh giấy ĐKKD ' + (index + 1))"
                  v-for="(image, index) in data?.businessRegistrationNumberImages"
                  :key="'dkkd-' + index"
                  class="image-item"
                >
                  <img :src="image" :alt="'ĐKKD ' + (index + 1)" class="clickable-image" />

                  <div class="image-overlay">
                    <i class="fas fa-eye"></i>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">Chưa có ảnh giấy ĐKKD</div>
            </div>

            <!-- Ảnh CCCD -->
            <div class="attachment-group">
              <label class="attachment-label">Ảnh CCCD:</label>
              <div class="image-gallery" v-if="data?.identityImages && data?.identityImages.length">
                <div
                  @click="viewImage(image, 'Ảnh CCCD ' + (index + 1))"
                  v-for="(image, index) in data?.identityImages"
                  :key="'cccd-' + index"
                  class="image-item"
                >
                  <img :src="image" :alt="'CCCD ' + (index + 1)" class="clickable-image" />
                  <div class="image-overlay">
                    <i class="fas fa-eye"></i>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">Chưa có ảnh CCCD</div>
            </div>

            <!-- File hợp đồng PDF -->
            <div class="attachment-group">
              <label class="attachment-label">File hợp đồng (PDF):</label>
              <div class="file-list" v-if="data?.contractFiles && data?.contractFiles.length">
                <div
                  v-for="(file, index) in data?.contractFiles"
                  :key="'contract-' + index"
                  class="file-item"
                >
                  <div class="file-icon">
                    <i class="fas fa-file-pdf text-danger"></i>
                  </div>
                  <div class="file-info">
                    <!-- <div class="file-name">{{ getFileNameFromUrl(file) }}</div> -->
                    <i
                      class="bx bxs-file-pdf ml-1 mt-4"
                      style="font-size: 50px; color: blue; text-align: center"
                    ></i>
                    <div class="file-actions btn-group">
                      <a :href="file" target="_blank" class="btn btn-sm">
                        <i class="bx bx-download"></i>
                      </a>
                      <button @click="viewPDF(file)" class="btn btn-sm">
                        <i class="bx bx-show"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">Chưa có file hợp đồng</div>
            </div>

            <!-- Ảnh hợp đồng -->
            <div class="attachment-group">
              <label class="attachment-label">Ảnh hợp đồng:</label>
              <div class="image-gallery" v-if="data?.contractImages && data?.contractImages.length">
                <div
                  @click="viewImage(image, 'Ảnh hợp đồng ' + (index + 1))"
                  v-for="(image, index) in data?.contractImages"
                  :key="'contract-img-' + index"
                  class="image-item"
                >
                  <img :src="image" :alt="'Hợp đồng ' + (index + 1)" class="clickable-image" />
                  <div class="image-overlay">
                    <i class="fas fa-eye"></i>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">Chưa có ảnh hợp đồng</div>
            </div>

            <!-- Ghi chú (nếu có) -->
            <div class="attachment-group" v-if="data?.note">
              <label class="attachment-label">Ghi chú:</label>
              <div class="note-content">{{ data?.note }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="text-center py-5">
        <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
        <h5>Không tìm thấy dữ liệu</h5>
        <p class="text-muted">Vui lòng kiểm tra lại hoặc liên hệ quản trị viên</p>
      </div>
    </div>

    <!-- Modal xem ảnh sử dụng b-modal -->
    <b-modal
      ref="imageModal"
      :title="currentImageTitle"
      size="lg"
      centered
      hide-footer
      body-class="p-0"
      @hidden="onModalHidden"
    >
      <div class="image-modal-body">
        <img :src="currentImageUrl" :alt="currentImageTitle" class="modal-image" />
      </div>
    </b-modal>

    <!-- Modal yêu cầu bổ sung với validation cải tiến -->
    <b-modal
      ref="supplementalModal"
      title="Yêu cầu bổ sung thông tin"
      @ok="confirmSupplemental"
      ok-title="Gửi yêu cầu"
      cancel-title="Hủy"
      :ok-disabled="submittingSupplemental"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="form-group">
        <label for="supplementalReasonCode" class="form-label">
          Lý do yêu cầu bổ sung <span class="text-danger">*</span>
        </label>
        <select
          id="supplementalReasonCode"
          v-model="supplementalReason"
          @change="onSupplementalReasonChange"
          style="border-radius: 5px"
          :class="{ 'is-invalid': supplementalReasonError }"
          :disabled="submittingSupplemental"
        >
          <option value="">-- Chọn lý do yêu cầu bổ sung --</option>
          <option
            v-for="reasonItem in supplementalReasonsOptions"
            :key="reasonItem?.code"
            :value="reasonItem?.code"
          >
            {{ reasonItem?.name }}
          </option>
        </select>
        <div v-if="supplementalReasonError" class="invalid-feedback">
          {{ supplementalReasonError }}
        </div>
      </div>

      <div class="form-group">
        <label for="supplementalNote" class="form-label"> Ghi chú </label>
        <textarea
          id="supplementalNote"
          v-model="supplementalNote"
          class="form-control"
          rows="3"
          placeholder="Ghi chú thêm (tùy chọn)..."
          :disabled="submittingSupplemental"
        >
        </textarea>
        <small class="form-text text-muted"> Thông tin bổ sung cho yêu cầu bổ sung </small>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button
          type="button"
          class="btn btn-secondary"
          @click="cancel()"
          :disabled="submittingSupplemental"
        >
          Hủy
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="ok()"
          :disabled="submittingSupplemental || !isSupplementalFormValid"
        >
          <span
            v-if="submittingSupplemental"
            class="spinner-border"
            style="width: 15px; height: 15px"
          ></span>
          {{ submittingSupplemental ? 'Loading...' : 'Gửi yêu cầu' }}
        </button>
      </template>
    </b-modal>

    <b-modal size="xs" v-model="toastModal.show" scrollable centered title="Thông báo">
      <div class="modal-body text-center">
        <img v-if="toastModal.success" src="@/assets/img/noti-success2.svg" alt="icon-successs" />
        <img v-else src="@/assets/img/noti-unsuccess2.svg" alt="icon-unsuccesss" />
        <h2 class="f18 py-3">{{ toastModal.title }}</h2>
        <p class="text-center" style="font-size: 14px">
          {{ toastModal.content }}
        </p>
      </div>
      <template #modal-footer="{}">
        <button
          type="button"
          class="btn btn-light"
          @click="toastModal.show = false"
          data-dismiss="modal"
        >
          Đóng
        </button>
      </template>
    </b-modal>
    <!-- Modal từ chối yêu cầu -->
    <b-modal
      ref="rejectionModal"
      title="Từ chối yêu cầu"
      @ok="confirmRejection"
      ok-title="Từ chối"
      ok-variant="danger"
      cancel-title="Hủy"
      :ok-disabled="submittingRejection"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="form-group">
        <label for="rejectionReasonCode" class="form-label">
          Lý do từ chối <span class="text-danger">*</span>
        </label>
        <select
          id="rejectionReasonCode"
          v-model="rejectionReasonCode"
          @change="onRejectionReasonCodeChange"
          style="border-radius: 5px"
          :class="{ 'is-invalid': rejectionReasonCodeError }"
          :disabled="submittingRejection"
        >
          <option value="">-- Chọn lý do từ chối --</option>
          <option
            v-for="reasonItem in rejectionReasonsOptions"
            :key="reasonItem?.code"
            :value="reasonItem?.code"
          >
            {{ reasonItem?.name }}
          </option>
        </select>
        <div v-if="rejectionReasonCodeError" class="invalid-feedback">
          {{ rejectionReasonCodeError }}
        </div>
      </div>

      <div class="form-group">
        <label for="rejectionNote" class="form-label"> Ghi chú </label>
        <textarea
          id="rejectionNote"
          v-model="rejectionNote"
          class="form-control"
          rows="3"
          placeholder="Ghi chú thêm (tùy chọn)..."
          :disabled="submittingRejection"
        >
        </textarea>
        <small class="form-text text-muted"> Thông tin bổ sung cho yêu cầu từ chối </small>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button
          type="button"
          class="btn btn-secondary"
          @click="cancel()"
          :disabled="submittingRejection"
        >
          Hủy
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="ok()"
          :disabled="submittingRejection || !isRejectionFormValid"
        >
          <span
            v-if="submittingRejection"
            class="spinner-border"
            style="width: 15px; height: 15px"
          ></span>
          {{ submittingRejection ? 'Loading...' : 'Từ chối' }}
        </button>
      </template>
    </b-modal>

    <!-- Modal cập nhật trạng thái chữ ký số -->
    <b-modal
      ref="digitalSignatureModal"
      title="Cập nhật trạng thái chữ ký số"
      @ok="confirmDigitalSignature"
      ok-title="Cập nhật"
      cancel-title="Hủy"
      :ok-disabled="submittingDigitalSignature"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="form-group">
        <label for="digitalSignatureRegistrationStatus" class="form-label">
          Trạng thái chữ ký số <span class="text-danger">*</span>
        </label>
        <select
          id="digitalSignatureRegistrationStatus"
          v-model="digitalSignatureRegistrationStatus"
          @change="onDigitalSignatureStatusChange"
          style="border-radius: 5px"
          :class="{ 'is-invalid': digitalSignatureRegistrationStatusError }"
          :disabled="submittingDigitalSignature"
        >
          <option value="">-- Chọn trạng thái chữ ký số --</option>
          <option
            v-for="statusItem in digitalSignatureStatusOptions"
            :key="statusItem?.code"
            :value="statusItem?.code"
          >
            {{ statusItem?.name }}
          </option>
        </select>
        <div v-if="digitalSignatureRegistrationStatusError" class="invalid-feedback">
          {{ digitalSignatureRegistrationStatusError }}
        </div>
      </div>

      <!-- Hiển thị khi chọn trạng thái REJECTED -->
      <div v-if="digitalSignatureRegistrationStatus === 'REJECTED'">
        <div class="form-group">
          <label for="digitalSignatureRejectionReasonCode" class="form-label">
            Lý do từ chối <span class="text-danger">*</span>
          </label>
          <select
            id="digitalSignatureRejectionReasonCode"
            v-model="digitalSignatureRejectionReasonCode"
            @change="onDigitalSignatureRejectionReasonCodeChange"
            style="border-radius: 5px"
            :class="{ 'is-invalid': digitalSignatureRejectionReasonCodeError }"
            :disabled="submittingDigitalSignature"
          >
            <option value="">-- Chọn lý do từ chối --</option>
            <option
              v-for="reasonItem in digitalSignatureRejectionReasonsOptions"
              :key="reasonItem?.code"
              :value="reasonItem?.code"
            >
              {{ reasonItem?.name }}
            </option>
          </select>
          <div v-if="digitalSignatureRejectionReasonCodeError" class="invalid-feedback">
            {{ digitalSignatureRejectionReasonCodeError }}
          </div>
        </div>

        <div class="form-group">
          <label for="digitalSignatureRejectionNote" class="form-label"> Ghi chú </label>
          <textarea
            id="digitalSignatureRejectionNote"
            v-model="digitalSignatureRejectionNote"
            class="form-control"
            rows="3"
            placeholder="Ghi chú thêm (tùy chọn)..."
            :disabled="submittingDigitalSignature"
          >
          </textarea>
          <small class="form-text text-muted"> Thông tin bổ sung cho việc từ chối chữ ký số </small>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button
          type="button"
          class="btn btn-secondary"
          @click="cancel()"
          :disabled="submittingDigitalSignature"
        >
          Hủy
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="ok()"
          :disabled="submittingDigitalSignature || !isDigitalSignatureFormValid"
        >
          <span
            v-if="submittingDigitalSignature"
            class="spinner-border"
            style="width: 15px; height: 15px"
          ></span>
          {{ submittingDigitalSignature ? 'Loading...' : 'Cập nhật' }}
        </button>
      </template>
    </b-modal>
    <!-- Modal cập nhật trạng thái thẩm định CQ thuế -->
    <b-modal
      ref="taxAuthorityModal"
      title="Cập nhật trạng thái thẩm định CQ thuế"
      @ok="confirmTaxAuthority"
      ok-title="Cập nhật"
      cancel-title="Hủy"
      :ok-disabled="submittingTaxAuthority"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="form-group">
        <label for="taxAuthorityVerifyStatus" class="form-label">
          Trạng thái thẩm định CQ thuế <span class="text-danger">*</span>
        </label>
        <select
          id="taxAuthorityVerifyStatus"
          v-model="taxAuthorityVerifyStatus"
          @change="onTaxAuthorityStatusChange"
          style="border-radius: 5px"
          :class="{ 'is-invalid': taxAuthorityVerifyStatusError }"
          :disabled="submittingTaxAuthority"
        >
          <option value="">-- Chọn trạng thái thẩm định CQ thuế --</option>
          <option
            v-for="statusItem in taxAuthorityStatusOptions"
            :key="statusItem?.code"
            :value="statusItem?.code"
          >
            {{ statusItem?.name }}
          </option>
        </select>
        <div v-if="taxAuthorityVerifyStatusError" class="invalid-feedback">
          {{ taxAuthorityVerifyStatusError }}
        </div>
      </div>

      <!-- Hiển thị khi chọn trạng thái REJECTED -->
      <div v-if="taxAuthorityVerifyStatus === 'REJECTED'">
        <div class="form-group">
          <label for="taxAuthorityRejectionReasonCode" class="form-label">
            Lý do từ chối <span class="text-danger">*</span>
          </label>
          <select
            id="taxAuthorityRejectionReasonCode"
            v-model="taxAuthorityRejectionReasonCode"
            @change="onTaxAuthorityRejectionReasonCodeChange"
            style="border-radius: 5px"
            :class="{ 'is-invalid': taxAuthorityRejectionReasonCodeError }"
            :disabled="submittingTaxAuthority"
          >
            <option value="">-- Chọn lý do từ chối --</option>
            <option
              v-for="reasonItem in taxAuthorityRejectionReasonsOptions"
              :key="reasonItem?.code"
              :value="reasonItem?.code"
            >
              {{ reasonItem?.name }}
            </option>
          </select>
          <div v-if="taxAuthorityRejectionReasonCodeError" class="invalid-feedback">
            {{ taxAuthorityRejectionReasonCodeError }}
          </div>
        </div>

        <div class="form-group">
          <label for="taxAuthorityRejectionNote" class="form-label"> Ghi chú </label>
          <textarea
            id="taxAuthorityRejectionNote"
            v-model="taxAuthorityRejectionNote"
            class="form-control"
            rows="3"
            placeholder="Ghi chú thêm (tùy chọn)..."
            :disabled="submittingTaxAuthority"
          >
          </textarea>
          <small class="form-text text-muted">
            Thông tin bổ sung cho việc từ chối thẩm định CQ thuế
          </small>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button
          type="button"
          class="btn btn-secondary"
          @click="cancel()"
          :disabled="submittingTaxAuthority"
        >
          Hủy
        </button>
        <button
          type="button"
          class="btn btn-info"
          @click="ok()"
          :disabled="submittingTaxAuthority || !isTaxAuthorityFormValid"
        >
          <span
            v-if="submittingTaxAuthority"
            class="spinner-border"
            style="width: 15px; height: 15px"
          ></span>
          {{ submittingTaxAuthority ? 'Loading...' : 'Cập nhật' }}
        </button>
      </template>
    </b-modal>
    <!-- Modal thông báo MC -->
    <!-- Modal thông báo MC - Thay thế modal cũ -->
    <b-modal
      ref="notifyMcModal"
      title="Thông báo MC hoàn tất cấu hình"
      @ok="confirmNotifyMc"
      ok-title="Gửi thông báo"
      cancel-title="Hủy"
      :ok-disabled="submittingNotifyMc"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <!-- Cảnh báo nếu đã gửi thông báo trước đó -->
      <div v-if="data?.countSendMailToMc > 0" class="alert alert-warning" role="alert">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        Đã gửi thông báo cho MC {{ data?.countSendMailToMc }} lần
      </div>

      <div class="row">
        <!-- Cột 1 -->
        <div class="col-md-6">
          <div class="form-group">
            <label for="usernamePosApp" class="form-label">
              Tên đăng nhập POS <span class="text-danger">*</span>
            </label>
            <input
              id="usernamePosApp"
              v-model="notifyMcForm.usernamePosApp"
              autocomplete="off"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.usernamePosApp }"
              placeholder="Nhập tên đăng nhập POS"
              :disabled="submittingNotifyMc"
              @input="onUsernamePosAppInput"
            />
            <div v-if="notifyMcForm.errors.usernamePosApp" class="invalid-feedback">
              {{ notifyMcForm.errors.usernamePosApp }}
            </div>
          </div>

          <div class="form-group">
            <label for="passwordPosApp" class="form-label">
              Mật khẩu POS <span class="text-danger">*</span>
            </label>
            <input
              id="passwordPosApp"
              v-model="notifyMcForm.passwordPosApp"
              autocomplete="off"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.passwordPosApp }"
              placeholder="Nhập mật khẩu POS"
              :disabled="submittingNotifyMc"
              @input="onPasswordPosAppInput"
            />
            <div v-if="notifyMcForm.errors.passwordPosApp" class="invalid-feedback">
              {{ notifyMcForm.errors.passwordPosApp }}
            </div>
          </div>

          <div class="form-group">
            <label for="companyName" class="form-label">
              Tên công ty <span class="text-danger">*</span>
            </label>
            <input
              id="companyName"
              v-model="notifyMcForm.companyName"
              autocomplete="off"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.companyName }"
              placeholder="Nhập tên công ty"
              :disabled="submittingNotifyMc"
              @input="onCompanyNameInput"
            />
            <div v-if="notifyMcForm.errors.companyName" class="invalid-feedback">
              {{ notifyMcForm.errors.companyName }}
            </div>
          </div>

          <div class="form-group">
            <label for="taxCode" class="form-label">
              Mã số thuế <span class="text-danger">*</span>
            </label>
            <input
              id="taxCode"
              v-model="notifyMcForm.taxCode"
              autocomplete="off"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.taxCode }"
              placeholder="Nhập mã số thuế"
              :disabled="submittingNotifyMc"
              @input="onTaxCodeInput"
            />
            <div v-if="notifyMcForm.errors.taxCode" class="invalid-feedback">
              {{ notifyMcForm.errors.taxCode }}
            </div>
          </div>
        </div>

        <!-- Cột 2 -->
        <div class="col-md-6">
          <div class="form-group">
            <label for="usernameInvoice" class="form-label">
              Tên đăng nhập hóa đơn <span class="text-danger">*</span>
            </label>
            <input
              id="usernameInvoice"
              v-model="notifyMcForm.usernameInvoice"
              autocomplete="off"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.usernameInvoice }"
              placeholder="Nhập tên đăng nhập hóa đơn"
              :disabled="submittingNotifyMc"
              @input="onUsernameInvoiceInput"
            />
            <div v-if="notifyMcForm.errors.usernameInvoice" class="invalid-feedback">
              {{ notifyMcForm.errors.usernameInvoice }}
            </div>
          </div>

          <div class="form-group">
            <label for="passwordInvoice" class="form-label">
              Mật khẩu hóa đơn <span class="text-danger">*</span>
            </label>
            <input
              id="passwordInvoice"
              v-model="notifyMcForm.passwordInvoice"
              autocomplete="off"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.passwordInvoice }"
              placeholder="Nhập mật khẩu hóa đơn"
              :disabled="submittingNotifyMc"
              @input="onPasswordInvoiceInput"
            />
            <div v-if="notifyMcForm.errors.passwordInvoice" class="invalid-feedback">
              {{ notifyMcForm.errors.passwordInvoice }}
            </div>
          </div>

          <div class="form-group">
            <label for="formNo" class="form-label">
              Số form <span class="text-danger">*</span>
            </label>
            <input
              id="formNo"
              v-model="notifyMcForm.formNo"
              autocomplete="off"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.formNo }"
              placeholder="Nhập số form"
              :disabled="submittingNotifyMc"
              @input="onFormNoInput"
            />
            <div v-if="notifyMcForm.errors.formNo" class="invalid-feedback">
              {{ notifyMcForm.errors.formNo }}
            </div>
          </div>

          <div class="form-group">
            <label for="serialNo" class="form-label">
              Số serial <span class="text-danger">*</span>
            </label>
            <input
              id="serialNo"
              v-model="notifyMcForm.serialNo"
              autocomplete="off"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': notifyMcForm.errors.serialNo }"
              placeholder="Nhập số serial"
              :disabled="submittingNotifyMc"
              @input="onSerialNoInput"
            />
            <div v-if="notifyMcForm.errors.serialNo" class="invalid-feedback">
              {{ notifyMcForm.errors.serialNo }}
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button
          type="button"
          class="btn btn-secondary"
          @click="cancel()"
          :disabled="submittingNotifyMc"
        >
          Hủy
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="ok()"
          :disabled="submittingNotifyMc || !isNotifyMcFormValid"
        >
          <span
            v-if="submittingNotifyMc"
            class="spinner-border"
            style="width: 15px; height: 15px"
          ></span>
          {{ submittingNotifyMc ? 'Loading...' : 'Gửi thông báo' }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { ComboService } from '@/services/combo.service'
  import Content from '@/components/common/Content.vue'
  import Card from '@/components/common/Card.vue'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  import { CommonService } from '@/services/common.service'

  export default {
    name: 'ComboRegistrationDetail',
    components: { Card, Content },
    data() {
      return {
        loading: false,
        data: null,
        comboId: this.$route.params.id,
        currentImageUrl: '',
        currentImageTitle: '',
        optionStatus: Config.optionStatusCombo,
        optionPaymentStatus: Config.optionPaymentStatusCombo,
        transferringToPending: false,
        toastModal: {
          show: false,
          success: true,
          title: '',
          content: '',
        },
        cancelling: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        // Thêm các biến cho modal yêu cầu bổ sung
        rejectionReasonCode: '',
        rejectionNote: '',
        rejectionReasonCodeError: '',
        submittingRejection: false,
        rejectionReasonsOptions: [],
        // Thêm các biến cho modal yêu cầu bổ sung
        supplementalReason: '',
        supplementalNote: '',
        supplementalReasonError: '',
        submittingSupplemental: false,
        supplementalReasonsOptions: [],

        // Thêm các biến cho modal cập nhật chữ ký số
        digitalSignatureRegistrationStatus: '',
        digitalSignatureRejectionReasonCode: '',
        digitalSignatureRejectionReason: '',
        digitalSignatureRejectionNote: '',
        digitalSignatureRegistrationStatusError: '',
        digitalSignatureRejectionReasonCodeError: '',
        submittingDigitalSignature: false,
        digitalSignatureRejectionReasonsOptions: [],
        digitalSignatureStatusOptions: [
          { code: 'PROCESSING', name: 'Đang xử lý' },
          { code: 'COMPLETED', name: 'Hoàn thành' },
          { code: 'REJECTED', name: 'Từ chối' },
        ],

        // Thêm các biến cho modal cập nhật thẩm định CQ thuế
        taxAuthorityVerifyStatus: '',
        taxAuthorityRejectionReasonCode: '',
        taxAuthorityRejectionReason: '',
        taxAuthorityRejectionNote: '',
        taxAuthorityVerifyStatusError: '',
        taxAuthorityRejectionReasonCodeError: '',
        submittingTaxAuthority: false,
        taxAuthorityRejectionReasonsOptions: [],
        taxAuthorityStatusOptions: [
          { code: 'PROCESSING', name: 'Đang xử lý' },
          { code: 'COMPLETED', name: 'Hoàn thành' },
          { code: 'REJECTED', name: 'Từ chối' },
        ],
        // Thêm các biến cho thông báo MC
        submittingNotifyMc: false,
        notifyMcForm: {
          usernamePosApp: '',
          passwordPosApp: '',
          companyName: '',
          taxCode: '',
          usernameInvoice: '',
          passwordInvoice: '',
          formNo: '',
          serialNo: '',
          errors: {
            usernamePosApp: '',
            passwordPosApp: '',
            companyName: '',
            taxCode: '',
            usernameInvoice: '',
            passwordInvoice: '',
            formNo: '',
            serialNo: '',
          },
        },
        optionCombo: [],
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getNameCombo() {
        return code => {
          const map = this.optionCombo.reduce((acc, curr) => {
            acc[curr.id] = curr.text
            return acc
          }, {})
          return map[code] || code || ''
        }
      },
      isRejectionFormValid() {
        return this.rejectionReasonCode.trim()
      },
      isSupplementalFormValid() {
        return this.supplementalReason.trim()
      },
      isDigitalSignatureFormValid() {
        const basicValid = this.digitalSignatureRegistrationStatus.trim()

        if (this.digitalSignatureRegistrationStatus === 'REJECTED') {
          return basicValid && this.digitalSignatureRejectionReasonCode.trim()
        }

        return basicValid
      },
      isTaxAuthorityFormValid() {
        const basicValid = this.taxAuthorityVerifyStatus.trim()

        if (this.taxAuthorityVerifyStatus === 'REJECTED') {
          return basicValid && this.taxAuthorityRejectionReasonCode.trim()
        }

        return basicValid
      },
      // Thêm computed cho validation form thông báo MC
      isNotifyMcFormValid() {
        return (
          this.notifyMcForm.usernamePosApp.trim() &&
          this.notifyMcForm.passwordPosApp.trim() &&
          this.notifyMcForm.companyName.trim() &&
          this.notifyMcForm.taxCode.trim() &&
          this.notifyMcForm.usernameInvoice.trim() &&
          this.notifyMcForm.passwordInvoice.trim() &&
          this.notifyMcForm.formNo.trim() &&
          this.notifyMcForm.serialNo.trim()
        )
      },
    },

    mounted() {
      this.loadData()
      this.getConfigSystem()
      this.loadNameCombo()
    },

    methods: {
      async loadNameCombo() {
        try {
          const data = await ComboService.getPlaneServiceCommbo({
            page: 1,
            size: 1000,
          })
          if (data.code === 1000) {
            const groupService = data.data?.groupService?.find(e => e.group === 'SELL')
            const comboService = groupService?.service?.find(e => e.code === 'COMBOSELL')
            const newData = comboService?.plan || []

            this.optionCombo =
              newData?.map(e => {
                return {
                  id: e.code,
                  text: e.title,
                  partnerPrice: e.partnerPrice,
                }
              }) || []

            console.log('optionCombo', this.optionCombo)
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Thêm methods cho thông báo MC
      showNotifyMcModal() {
        this.resetNotifyMcForm()
        this.$refs.notifyMcModal.show()
      },

      async confirmNotifyMc(bvModalEvent) {
        // Ngăn modal đóng mặc định
        bvModalEvent.preventDefault()

        // Reset errors
        this.resetNotifyMcErrors()

        // Validate form
        let isValid = true

        if (!this.notifyMcForm.usernamePosApp.trim()) {
          this.notifyMcForm.errors.usernamePosApp = 'Vui lòng nhập tên đăng nhập'
          isValid = false
        }

        if (!this.notifyMcForm.passwordPosApp.trim()) {
          this.notifyMcForm.errors.passwordPosApp = 'Vui lòng nhập mật khẩu'
          isValid = false
        }

        if (!this.notifyMcForm.companyName.trim()) {
          this.notifyMcForm.errors.companyName = 'Vui lòng nhập tên công ty'
          isValid = false
        }

        if (!this.notifyMcForm.taxCode.trim()) {
          this.notifyMcForm.errors.taxCode = 'Vui lòng nhập mã số thuế'
          isValid = false
        }

        if (!this.notifyMcForm.usernameInvoice.trim()) {
          this.notifyMcForm.errors.usernameInvoice = 'Vui lòng nhập tên đăng nhập hóa đơn'
          isValid = false
        }

        if (!this.notifyMcForm.passwordInvoice.trim()) {
          this.notifyMcForm.errors.passwordInvoice = 'Vui lòng nhập mật khẩu hóa đơn'
          isValid = false
        }

        if (!this.notifyMcForm.formNo.trim()) {
          this.notifyMcForm.errors.formNo = 'Vui lòng nhập số form'
          isValid = false
        }

        if (!this.notifyMcForm.serialNo.trim()) {
          this.notifyMcForm.errors.serialNo = 'Vui lòng nhập số serial'
          isValid = false
        }

        if (!isValid) {
          return // Không đóng modal
        }

        try {
          this.submittingNotifyMc = true

          const payload = {
            id: this.comboId,
            actionType: 'NOTICE_MC_REQUEST_APPROVE',
            usernamePosApp: this.notifyMcForm.usernamePosApp.trim(),
            passwordPosApp: this.notifyMcForm.passwordPosApp.trim(),
            companyName: this.notifyMcForm.companyName.trim(),
            taxCode: this.notifyMcForm.taxCode.trim(),
            usernameInvoice: this.notifyMcForm.usernameInvoice.trim(),
            passwordInvoice: this.notifyMcForm.passwordInvoice.trim(),
            formNo: this.notifyMcForm.formNo.trim(),
            serialNo: this.notifyMcForm.serialNo.trim(),
          }

          const response = await ComboService.updateComboStatus(payload)

          if (response.code === 1000) {
            this.showToastModal(true, 'Thành công', 'Gửi thông báo MC hoàn tất cấu hình thành công')
            // Reload data để cập nhật số lần gửi
            await this.loadData()
            // Reset form và đóng modal
            this.resetNotifyMcForm()
            this.$nextTick(() => {
              this.$refs.notifyMcModal.hide()
            })
          } else {
            this.showToastModal(
              false,
              'Thất bại',
              response.message || 'Có lỗi xảy ra khi gửi thông báo MC'
            )
          }
        } catch (error) {
          console.error('Error notifying MC:', error)
          this.showToastModal(false, 'Lỗi', 'Có lỗi xảy ra khi gửi thông báo MC')
        } finally {
          this.submittingNotifyMc = false
        }
      },

      resetNotifyMcForm() {
        this.notifyMcForm.usernamePosApp = ''
        this.notifyMcForm.passwordPosApp = ''
        this.notifyMcForm.companyName = ''
        this.notifyMcForm.taxCode = ''
        this.notifyMcForm.usernameInvoice = ''
        this.notifyMcForm.passwordInvoice = ''
        this.notifyMcForm.formNo = ''
        this.notifyMcForm.serialNo = ''
        this.resetNotifyMcErrors()
      },

      resetNotifyMcErrors() {
        this.notifyMcForm.errors.usernamePosApp = ''
        this.notifyMcForm.errors.passwordPosApp = ''
        this.notifyMcForm.errors.companyName = ''
        this.notifyMcForm.errors.taxCode = ''
        this.notifyMcForm.errors.usernameInvoice = ''
        this.notifyMcForm.errors.passwordInvoice = ''
        this.notifyMcForm.errors.formNo = ''
        this.notifyMcForm.errors.serialNo = ''
      },
      onCompanyNameInput() {
        if (this.notifyMcForm.errors.companyName && this.notifyMcForm.companyName.trim()) {
          this.notifyMcForm.errors.companyName = ''
        }
      },

      onTaxCodeInput() {
        if (this.notifyMcForm.errors.taxCode && this.notifyMcForm.taxCode.trim()) {
          this.notifyMcForm.errors.taxCode = ''
        }
      },

      onUsernameInvoiceInput() {
        if (this.notifyMcForm.errors.usernameInvoice && this.notifyMcForm.usernameInvoice.trim()) {
          this.notifyMcForm.errors.usernameInvoice = ''
        }
      },

      onPasswordInvoiceInput() {
        if (this.notifyMcForm.errors.passwordInvoice && this.notifyMcForm.passwordInvoice.trim()) {
          this.notifyMcForm.errors.passwordInvoice = ''
        }
      },

      onFormNoInput() {
        if (this.notifyMcForm.errors.formNo && this.notifyMcForm.formNo.trim()) {
          this.notifyMcForm.errors.formNo = ''
        }
      },

      onSerialNoInput() {
        if (this.notifyMcForm.errors.serialNo && this.notifyMcForm.serialNo.trim()) {
          this.notifyMcForm.errors.serialNo = ''
        }
      },
      // Thêm event handlers để clear error khi user nhập
      onUsernamePosAppInput() {
        if (this.notifyMcForm.errors.usernamePosApp && this.notifyMcForm.usernamePosApp.trim()) {
          this.notifyMcForm.errors.usernamePosApp = ''
        }
      },

      onPasswordPosAppInput() {
        if (this.notifyMcForm.errors.passwordPosApp && this.notifyMcForm.passwordPosApp.trim()) {
          this.notifyMcForm.errors.passwordPosApp = ''
        }
      },

      getContractUrl(contractId) {
        return `/contract-detail-paper/${contractId}`
      },
      handleCreateContract() {
        // this.$router.push(`/create-combo-contract?agentName=${this.data?.agentName}&agentId=${this.data?.createdBy}&code=${this.data?.code}&merchantName=${this.data?.merchantName}`)
        const queryParams = {
          agentName: this.data?.agentName,
          agentId: this.data?.createdBy,
          code: this.data?.code,
          merchantName: this.data?.merchantName,
          businessRegistrationNumber: this.data?.businessRegistrationNumber,
          merchantAddress: this.data?.merchantAddress,
          representativeName: this.data?.representativeName,
          representativeEmail: this.data?.representativeEmail,
          representativeMobile: this.data?.representativeMobile,
          identityNumber: this.data?.identityNumber,
          partnerCode: this.data?.partnerCode,
          packageCode: this.data?.packageCode,
        }
        this.$router.push({ path: '/create-combo-contract', query: queryParams })
      },
      showTaxAuthorityModal() {
        this.taxAuthorityVerifyStatus = ''
        this.taxAuthorityRejectionReasonCode = ''
        this.taxAuthorityRejectionReason = ''
        this.taxAuthorityRejectionNote = ''
        this.taxAuthorityVerifyStatusError = ''
        this.taxAuthorityRejectionReasonCodeError = ''
        this.submittingTaxAuthority = false
        this.$refs.taxAuthorityModal.show()
      },

      async confirmTaxAuthority(bvModalEvent) {
        // Ngăn modal đóng mặc định
        bvModalEvent.preventDefault()

        // Reset errors
        this.taxAuthorityVerifyStatusError = ''
        this.taxAuthorityRejectionReasonCodeError = ''

        // Validate form
        let isValid = true

        if (!this.taxAuthorityVerifyStatus.trim()) {
          this.taxAuthorityVerifyStatusError = 'Vui lòng chọn trạng thái thẩm định CQ thuế'
          isValid = false
        }

        if (this.taxAuthorityVerifyStatus === 'REJECTED') {
          if (!this.taxAuthorityRejectionReasonCode.trim()) {
            this.taxAuthorityRejectionReasonCodeError = 'Vui lòng chọn lý do từ chối'
            isValid = false
          }
        }

        if (!isValid) {
          return // Không đóng modal
        }

        try {
          this.submittingTaxAuthority = true

          const payload = {
            id: this.comboId,
            actionType: 'UPDATE_STATUS_TAX_AUTHORITY_VERIFY',
            taxAuthorityVerifyStatus: this.taxAuthorityVerifyStatus.trim(),
            taxAuthorityRejectionReasonCode:
              this.taxAuthorityVerifyStatus === 'REJECTED'
                ? this.taxAuthorityRejectionReasonCode.trim()
                : null,
            taxAuthorityRejectionReason:
              this.taxAuthorityVerifyStatus === 'REJECTED'
                ? this.taxAuthorityRejectionReasonsOptions.find(
                    reason => reason.code === this.taxAuthorityRejectionReasonCode.trim()
                  )?.name
                : null,
            taxAuthorityRejectionNote:
              this.taxAuthorityVerifyStatus === 'REJECTED'
                ? this.taxAuthorityRejectionNote.trim() || null
                : null,
          }

          const response = await ComboService.updateComboStatus(payload)

          if (response.code === 1000) {
            this.showToastModal(
              true,
              'Thành công',
              'Cập nhật trạng thái thẩm định CQ thuế thành công'
            )
            // Reload data để cập nhật trạng thái mới
            await this.loadData()
            // Reset form và đóng modal
            this.resetTaxAuthorityForm()
            this.$nextTick(() => {
              this.$refs.taxAuthorityModal.hide()
            })
          } else {
            this.showToastModal(
              false,
              'Thất bại',
              response.message || 'Có lỗi xảy ra khi cập nhật trạng thái thẩm định CQ thuế'
            )
          }
        } catch (error) {
          console.error('Error updating tax authority status:', error)
          this.showToastModal(
            false,
            'Lỗi',
            'Có lỗi xảy ra khi cập nhật trạng thái thẩm định CQ thuế'
          )
        } finally {
          this.submittingTaxAuthority = false
        }
      },

      onTaxAuthorityStatusChange() {
        if (this.taxAuthorityVerifyStatusError && this.taxAuthorityVerifyStatus.trim()) {
          this.taxAuthorityVerifyStatusError = ''
        }

        // Reset rejection fields when not REJECTED
        if (this.taxAuthorityVerifyStatus !== 'REJECTED') {
          this.taxAuthorityRejectionReasonCode = ''
          this.taxAuthorityRejectionReason = ''
          this.taxAuthorityRejectionNote = ''
          this.taxAuthorityRejectionReasonCodeError = ''
        }
      },

      onTaxAuthorityRejectionReasonCodeChange() {
        if (
          this.taxAuthorityRejectionReasonCodeError &&
          this.taxAuthorityRejectionReasonCode.trim()
        ) {
          this.taxAuthorityRejectionReasonCodeError = ''
        }
      },

      resetTaxAuthorityForm() {
        this.taxAuthorityVerifyStatus = ''
        this.taxAuthorityRejectionReasonCode = ''
        this.taxAuthorityRejectionReason = ''
        this.taxAuthorityRejectionNote = ''
        this.taxAuthorityVerifyStatusError = ''
        this.taxAuthorityRejectionReasonCodeError = ''
      },

      showDigitalSignatureModal() {
        this.digitalSignatureRegistrationStatus = ''
        this.digitalSignatureRejectionReasonCode = ''
        this.digitalSignatureRejectionReason = ''
        this.digitalSignatureRejectionNote = ''
        this.digitalSignatureRegistrationStatusError = ''
        this.digitalSignatureRejectionReasonCodeError = ''
        this.submittingDigitalSignature = false
        this.$refs.digitalSignatureModal.show()
      },
      async confirmDigitalSignature(bvModalEvent) {
        // Ngăn modal đóng mặc định
        bvModalEvent.preventDefault()

        // Reset errors
        this.digitalSignatureRegistrationStatusError = ''
        this.digitalSignatureRejectionReasonCodeError = ''

        // Validate form
        let isValid = true

        if (!this.digitalSignatureRegistrationStatus.trim()) {
          this.digitalSignatureRegistrationStatusError = 'Vui lòng chọn trạng thái chữ ký số'
          isValid = false
        }

        if (this.digitalSignatureRegistrationStatus === 'REJECTED') {
          if (!this.digitalSignatureRejectionReasonCode.trim()) {
            this.digitalSignatureRejectionReasonCodeError = 'Vui lòng chọn lý do từ chối'
            isValid = false
          }
        }

        if (!isValid) {
          return // Không đóng modal
        }

        try {
          this.submittingDigitalSignature = true

          const payload = {
            id: this.comboId,
            actionType: 'UPDATE_STATUS_DIGITAL_SIGNATURE',
            digitalSignatureRegistrationStatus: this.digitalSignatureRegistrationStatus.trim(),
            digitalSignatureRejectionReasonCode:
              this.digitalSignatureRegistrationStatus === 'REJECTED'
                ? this.digitalSignatureRejectionReasonCode.trim()
                : null,
            digitalSignatureRejectionReason:
              this.digitalSignatureRegistrationStatus === 'REJECTED'
                ? this.digitalSignatureRejectionReasonsOptions.find(
                    reason => reason.code === this.digitalSignatureRejectionReasonCode.trim()
                  )?.name
                : null,
            digitalSignatureRejectionNote:
              this.digitalSignatureRegistrationStatus === 'REJECTED'
                ? this.digitalSignatureRejectionNote.trim() || null
                : null,
          }

          const response = await ComboService.updateComboStatus(payload)

          if (response.code === 1000) {
            this.showToastModal(true, 'Thành công', 'Cập nhật trạng thái chữ ký số thành công')
            // Reload data để cập nhật trạng thái mới
            await this.loadData()
            // Reset form và đóng modal
            this.resetDigitalSignatureForm()
            this.$nextTick(() => {
              this.$refs.digitalSignatureModal.hide()
            })
          } else {
            this.showToastModal(
              false,
              'Thất bại',
              response.message || 'Có lỗi xảy ra khi cập nhật trạng thái chữ ký số'
            )
          }
        } catch (error) {
          console.error('Error updating digital signature status:', error)
          this.showToastModal(false, 'Lỗi', 'Có lỗi xảy ra khi cập nhật trạng thái chữ ký số')
        } finally {
          this.submittingDigitalSignature = false
        }
      },

      onDigitalSignatureStatusChange() {
        if (
          this.digitalSignatureRegistrationStatusError &&
          this.digitalSignatureRegistrationStatus.trim()
        ) {
          this.digitalSignatureRegistrationStatusError = ''
        }

        // Reset rejection fields when not REJECTED
        if (this.digitalSignatureRegistrationStatus !== 'REJECTED') {
          this.digitalSignatureRejectionReasonCode = ''
          this.digitalSignatureRejectionReason = ''
          this.digitalSignatureRejectionNote = ''
          this.digitalSignatureRejectionReasonCodeError = ''
        }
      },

      onDigitalSignatureRejectionReasonCodeChange() {
        if (
          this.digitalSignatureRejectionReasonCodeError &&
          this.digitalSignatureRejectionReasonCode.trim()
        ) {
          this.digitalSignatureRejectionReasonCodeError = ''
        }
      },

      resetDigitalSignatureForm() {
        this.digitalSignatureRegistrationStatus = ''
        this.digitalSignatureRejectionReasonCode = ''
        this.digitalSignatureRejectionReason = ''
        this.digitalSignatureRejectionNote = ''
        this.digitalSignatureRegistrationStatusError = ''
        this.digitalSignatureRejectionReasonCodeError = ''
      },
      showRejectionModal() {
        this.rejectionReasonCode = ''
        this.rejectionNote = ''
        this.rejectionReasonCodeError = ''
        this.submittingRejection = false
        this.$refs.rejectionModal.show()
      },
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data?.success) {
              const config = data?.data
              this.rejectionReasonsOptions = config.agentRequestComboRejectionReason || []
              this.supplementalReasonsOptions =
                config.agentRequestComboSupplementRequestReason || []
              this.digitalSignatureRejectionReasonsOptions =
                config.agentRequestComboDigitalSignatureRejectionReason || []
              this.taxAuthorityRejectionReasonsOptions =
                config.agentRequestComboTaxAuthorityRejectionReason || []
            }
          })
          .catch(error => console.log(error))
      },
      async confirmRejection(bvModalEvent) {
        // Ngăn modal đóng mặc định
        bvModalEvent.preventDefault()

        // Reset errors
        this.rejectionReasonCodeError = ''

        // Validate form
        let isValid = true

        if (!this.rejectionReasonCode.trim()) {
          this.rejectionReasonCodeError = 'Vui lòng chọn lý do từ chối'
          isValid = false
        }

        if (!isValid) {
          return // Không đóng modal
        }

        try {
          this.submittingRejection = true

          const payload = {
            id: this.comboId,
            actionType: 'REJECT',
            rejectionReasonCode: this.rejectionReasonCode.trim(),
            rejectionNote: this.rejectionNote.trim() || null,
            rejectionReason: this.rejectionReasonsOptions.find(
              reason => reason.code === this.rejectionReasonCode.trim()
            )?.name,
          }

          const response = await ComboService.updateComboStatus(payload)

          if (response.code === 1000) {
            this.showToastModal(true, 'Thành công', 'Từ chối yêu cầu thành công')
            // Reload data để cập nhật trạng thái mới
            await this.loadData()
            // Reset form và đóng modal
            this.resetRejectionForm()
            this.$nextTick(() => {
              this.$refs.rejectionModal.hide()
            })
          } else {
            this.showToastModal(
              false,
              'Thất bại',
              response.message || 'Có lỗi xảy ra khi từ chối yêu cầu'
            )
          }
        } catch (error) {
          console.error('Error rejecting request:', error)
          this.showToastModal(false, 'Lỗi', 'Có lỗi xảy ra khi từ chối yêu cầu')
        } finally {
          this.submittingRejection = false
        }
      },

      onRejectionReasonCodeChange() {
        if (this.rejectionReasonCodeError && this.rejectionReasonCode.trim()) {
          this.rejectionReasonCodeError = ''
        }
      },

      onRejectionReasonInput() {
        if (this.rejectionReasonError && this.rejectionReason.trim()) {
          this.rejectionReasonError = ''
        }
      },

      resetRejectionForm() {
        this.rejectionReasonCode = ''
        this.rejectionNote = ''
        this.rejectionReasonCodeError = ''
      },
      showSupplementalModal() {
        this.supplementalReason = ''
        this.supplementalNote = ''
        this.supplementalReasonError = ''
        this.submittingSupplemental = false
        this.$refs.supplementalModal.show()
      },
      // Thêm method hiển thị modal yêu cầu bổ sung
      async confirmSupplemental(bvModalEvent) {
        // Ngăn modal đóng mặc định
        bvModalEvent.preventDefault()

        // Reset errors
        this.supplementalReasonError = ''

        // Validate form
        let isValid = true

        if (!this.supplementalReason.trim()) {
          this.supplementalReasonError = 'Vui lòng chọn lý do yêu cầu bổ sung'
          isValid = false
        }

        if (!isValid) {
          return // Không đóng modal
        }

        try {
          this.submittingSupplemental = true

          const payload = {
            id: this.comboId,
            actionType: 'REQUEST_SUPPLEMENTAL',
            supplementRequestReasonCode: this.supplementalReason.trim(),
            supplementRequestNote: this.supplementalNote.trim() || null,
            supplementRequestReason: this.supplementalReasonsOptions.find(
              reason => reason.code === this.supplementalReason.trim()
            )?.name,
          }

          const response = await ComboService.updateComboStatus(payload)

          if (response.code === 1000) {
            this.showToastModal(true, 'Thành công', 'Gửi yêu cầu bổ sung thành công')
            // Reload data để cập nhật trạng thái mới
            await this.loadData()
            // Reset form và đóng modal
            this.resetSupplementalForm()
            this.$nextTick(() => {
              this.$refs.supplementalModal.hide()
            })
          } else {
            this.showToastModal(
              false,
              'Thất bại',
              response.message || 'Có lỗi xảy ra khi gửi yêu cầu bổ sung'
            )
          }
        } catch (error) {
          console.error('Error requesting supplemental:', error)
          this.showToastModal(false, 'Lỗi', 'Có lỗi xảy ra khi gửi yêu cầu bổ sung')
        } finally {
          this.submittingSupplemental = false
        }
      },

      // Thêm method để clear error khi người dùng bắt đầu nhập
      onSupplementalReasonInput() {
        if (this.supplementalReasonError && this.supplementalReason.trim()) {
          this.supplementalReasonError = ''
        }
      },

      resetSupplementalForm() {
        this.supplementalReason = ''
        this.supplementalNote = ''
        this.supplementalReasonError = ''
      },

      onSupplementalReasonChange() {
        if (this.supplementalReasonError && this.supplementalReason.trim()) {
          this.supplementalReasonError = ''
        }
      },

      showToastModal(success, title, content) {
        this.toastModal = {
          show: true,
          success: success,
          title: title,
          content: content,
        }
      },
      showTransferPendingModal() {
        this.$refs.transferPendingModal.show()
      },

      async confirmTransferPending() {
        try {
          this.transferringToPending = true

          const payload = {
            id: this.comboId,
            actionType: 'TRANSFER_TO_PENDING',
          }

          const response = await ComboService.updateComboStatus(payload)

          if (response.code === 1000) {
            this.showToastModal(true, 'Thành công', 'Chuyển trạng thái thành công')
            // Reload data để cập nhật trạng thái mới
            await this.loadData()
          } else {
            this.showToastModal(false, 'Thất bại', response.message || 'Có lỗi xảy ra')
          }
        } catch (error) {
          console.error('Error transferring to pending:', error)
          this.showToastModal(false, 'Lỗi', 'Có lỗi xảy ra khi chuyển trạng thái')
        } finally {
          this.transferringToPending = false
        }
      },
      async loadData() {
        try {
          this.loading = true
          const response = await ComboService.detailCombo(this.comboId)

          if (response.code === 1000) {
            this.data = response.data
          } else {
            this.$toast.error(response.message || 'Không thể tải dữ liệu')
          }
        } catch (error) {
          console.error('Error loading data:', error)
          this.$toast.error('Có lỗi xảy ra khi tải dữ liệu')
        } finally {
          this.loading = false
        }
      },

      getStatusClass(status) {
        const map = this.optionStatus?.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },
      getDigitalSignatureRegistrationStatus(status) {
        const map = Config.digitalSignatureRegistrationStatus?.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },
      getTaxAuthorityVerifyStatus(status) {
        const map = Config.taxAuthorityVerifyStatus?.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[status] || 'badge-secondary'
      },

      getPaymentStatusBadgeClass(paymentStatus) {
        const map = this.optionPaymentStatus.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        }, {})
        return map[paymentStatus] || 'badge-secondary'
      },

      formatDate(dateString) {
        if (!dateString) return 'Chưa có thông tin'

        try {
          const date = new Date(dateString)
          return date.toLocaleString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
        } catch (error) {
          return 'Không hợp lệ'
        }
      },

      getFileNameFromUrl(url) {
        if (!url) return 'file.pdf'
        return url.split('/').pop() || 'file.pdf'
      },

      viewImage(imageUrl, title) {
        this.currentImageUrl = imageUrl
        this.currentImageTitle = title
        this.$refs.imageModal.show()
      },

      onModalHidden() {
        this.currentImageUrl = ''
        this.currentImageTitle = ''
      },

      viewPDF(pdfUrl) {
        window.open(pdfUrl, '_blank')
      },

      editCombo() {
        this.$router.push(`/sales-combos-edit/${this.comboId}`)
      },
      editComboAdditional() {
        this.$router.push(`/sales-combos-edit/${this.comboId}?action=SUPPLEMENTAL_UPDATE`)
      },

      goBack() {
        this.$router.push('/request-sales-combo')
      },
    },
  }
</script>

<style scoped>
  .breadcrumb-area {
    display: flex;
    height: 24px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .info-group {
    margin-bottom: 1rem;
  }

  .info-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.25rem;
    display: block;
  }

  .info-value {
    padding: 0.5rem 0.75rem;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 0.375rem;
    min-height: 38px;
    display: flex;
    align-items: center;
  }

  .attachment-group {
    margin-bottom: 2rem;
  }

  .attachment-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.75rem;
    display: block;
  }

  .image-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .image-item {
    position: relative;
    width: 120px;
    height: 120px;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .image-item:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .image-item:hover .image-overlay {
    opacity: 1;
  }

  .clickable-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    color: white;
    font-size: 1.5rem;
  }

  .file-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .file-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    background: #f8f9fa;
    width: 125px;
    position: relative;
  }

  .file-icon {
    margin-right: 1rem;
    font-size: 2rem;
  }

  .file-info {
    flex: 1;
  }

  .file-name {
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .file-actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
  }

  .no-data {
    padding: 2rem;
    text-align: center;
    color: #6c757d;
    width: 125px;
    background: #f8f9fa;
    border: 1px dashed #dee2e6;
    border-radius: 0.5rem;
    font-style: italic;
  }

  .note-content {
    padding: 1rem;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 0.375rem;
    white-space: pre-wrap;
    line-height: 1.6;
  }

  .badge {
    padding: 0.5rem 0.75rem;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    font-weight: 600;
  }

  .badge-secondary {
    background-color: #6c757d;
    color: white;
  }

  .badge-warning {
    background-color: #ffc107;
    color: #212529;
  }

  .badge-success {
    background-color: #198754;
    color: white;
  }

  .badge-danger {
    background-color: #dc3545;
    color: white;
  }

  .badge-info {
    background-color: #0dcaf0;
    color: #212529;
  }

  /* Modal xem ảnh với b-modal */
  .image-modal-body {
    text-align: center;
    padding: 1rem;
  }

  .modal-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 0.5rem;
  }

  .spinner-border {
    width: 3rem;
    height: 3rem;
  }

  /* Style cho form trong modal yêu cầu bổ sung */
  .form-group {
    margin-bottom: 1rem;
  }

  .form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
  }

  .form-control {
    border-radius: 0.375rem;
    border: 1px solid #ced4da;
    padding: 0.75rem;
    font-size: 0.875rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .form-control:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
    outline: 0;
  }

  .form-control.is-invalid {
    border-color: #dc3545;
  }

  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #dc3545;
  }

  .form-text {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: #6c757d;
  }

  .text-danger {
    color: #dc3545 !important;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .image-item {
      width: 100px;
      height: 100px;
    }

    .file-item {
      flex-direction: column;
      text-align: center;
    }

    .file-icon {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }

    .breadcrumb-area {
      flex-direction: column;
      height: auto;
      gap: 1rem;
    }

    .breadcrumb-area > div {
      display: flex;
      gap: 0.5rem;
    }
  }

  /* Thêm style cho alert cảnh báo */
  .alert-warning {
    border-left: 4px solid #ffc107;
    background-color: #fff3cd;
    border-color: #ffecb5;
    color: #664d03;
  }

  .alert-warning .fas {
    color: #ffc107;
  }
</style>
